import "./FromDigitalToFabric.module.css";
import Header from "@/reusable_sections/Header";
import Printing from "./sections/Printing";
import Specifications from "./sections/Specifications";
import Printingfaq from "./sections/Printingfaq";
import Footer from "@/reusable_sections/Footer";
export default function FromDigitalToFabricPage() {
  return <div>
      <Header />
      <Printing />
      <Specifications />
      <Printingfaq />
      <Footer />
    </div>;
}